import React, {useState} from 'react';
import {UsePermissions} from "../../hooks/usePermissions";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import { TabView, TabPanel } from 'primereact/tabview';
import {Navigate} from "react-router";
import {PagoLiquidacion} from "./components/seccionPagos/PagoLiquidacion";
import {DevolucionPagos} from "./components/seccionDevolucionPagos/DevolucionPagos";
export const PagoLiquidacionPage = () => {
    const [permisos] = UsePermissions();
    const [activeIndex, setActiveIndex] = useState(0);


    return (
        <div className="container-relative">
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

                <TabView  activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel   header="Pago de liquidación">
                        <ContainerTable>
                            {permisos.consultar ? <PagoLiquidacion />: <Navigate to="/home"/>}
                        </ContainerTable>
                    </TabPanel>
                    <TabPanel header="Devolución de pagos">
                        <ContainerTable>
                            {permisos.consultar ? <DevolucionPagos />: <Navigate to="/home"/>}
                        </ContainerTable>
                    </TabPanel>

                </TabView>

        </div>
    );
};


